function getTime (dateStr) {
  // 兼容mac
  if(!dateStr){ 
    return ''
  }
  if(dateStr.toLowerCase().indexOf("t")==-1){
    dateStr = dateStr.replace(/-/g, '/')
  }  
  const date = new Date(dateStr);
  
  return {
    getFullYear: date.getFullYear(),
    getMonth: (date.getMonth() + 1) > 9 ? date.getMonth() + 1 : '0' + (date.getMonth() + 1),
    getDate: date.getDate() > 9 ? date.getDate() : '0' + date.getDate(),
    getHours: date.getHours() > 9 ? date.getHours() : '0' + date.getHours(),
    getMinutes: date.getMinutes() > 9 ? date.getMinutes() : '0' + date.getMinutes(),
    getSeconds: date.getSeconds() > 9 ? date.getSeconds() : '0' + date.getSeconds()
  }
}
function StampgetTime (dateStr) {
  // 兼容mac
  if(!dateStr){ return }  
  const date = new Date(dateStr)
  
  return {
    getFullYear: date.getFullYear(),
    getMonth: (date.getMonth() + 1) > 9 ? date.getMonth() + 1 : '0' + (date.getMonth() + 1),
    getDate: date.getDate() > 9 ? date.getDate() : '0' + date.getDate(),
    getHours: date.getHours() > 9 ? date.getHours() : '0' + date.getHours(),
    getMinutes: date.getMinutes() > 9 ? date.getMinutes() : '0' + date.getMinutes(),
    getSeconds: date.getSeconds() > 9 ? date.getSeconds() : '0' + date.getSeconds()
  }
}

// 获取到分钟 2018-11-11 12:12
export function StampgetTimeM (dateStr) {
  if(!dateStr){ return }
  const date = StampgetTime(dateStr)
  return `${date.getFullYear}-${date.getMonth}-${date.getDate} ${date.getHours}:${date.getMinutes}`
}
// 获取到分钟 2018-11-11 12:12
export function getTimeM (dateStr) {
  if( !dateStr ) return;
  const date = getTime(dateStr)
  return `${date.getFullYear}-${date.getMonth}-${date.getDate} ${date.getHours}:${date.getMinutes}`
}
// 获取到S的时间  2018-09-10 23:59:59
export function getTimeS (dateStr) {
  if (!dateStr) return
  const date = getTime(dateStr)
  return `${date.getFullYear}-${date.getMonth}-${date.getDate} ${date.getHours}:${date.getMinutes}:${date.getSeconds}`
}
// 获取到日 2018-12-12
export function getTimeD (dateStr) {
  if(!dateStr){return '';}
  const date = getTime(dateStr)
  return `${date.getFullYear}-${date.getMonth}-${date.getDate}`
}
// 计算两个时间相差几个月份
export function getMonths (startdata, enddata) {
  // 拆分年月日
  startdata = startdata.split('-')
  // 得到月数
  startdata = parseInt(startdata[0]) * 12 + parseInt(startdata[1])
  // 拆分年月日
  enddata = enddata.split('-')
  // 得到月数
  enddata = parseInt(enddata[0]) * 12 + parseInt(enddata[1])
  var m = Math.abs(startdata - enddata)
  return m
}
// 获取一组数据中的最大时间
export function getMaxdate (dataArr) {
  var newArray = Array.from(new Set(dataArr))
  var maxNum = Math.max(...newArray)
  console.log(maxNum)
  return maxNum
}



// WEBPACK FOOTER //
// ./src/utils/date.js